import { DISPLAY_MODES, SEARCH_PARAM_DISPLAY_KEY } from "../constants";
import { LocationSource } from "../CoreApp/LocationSource";

/**
 * URL is the source of truth for directory state (directory-as-display
 * model — same shape as isInViewManager). Reads ?display=directory
 * directly from the current URL so both in-app toggle and cold-start
 * deep links land in the same state.
 */
export function isInDirectory() {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(LocationSource.getSearch());
  return params.get(SEARCH_PARAM_DISPLAY_KEY) === DISPLAY_MODES.DIRECTORY;
}
